import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import { useEffect, useState, useRef } from 'react';
import helpers from '../utils/fieldsHelper';
import lookup from './lookup';
import Utils from '../../../../utils';
import useFormContext from '../context/useFormContext';
/**
 *
 * @param {import('./types').EcrionFieldsBinding} binding
 * @param {import('../logic/types').EcrionFormFields} fields
 * @returns {Array<import('./types').LookupColumn>}
 */

var readColumns = function readColumns(binding, fields) {
  if (!binding || !fields) return [];
  return binding.fields.map(function (m) {
    var field = fields[m.fieldId];
    var name = field ? field.caption : m.fieldId;
    var hideInLookupDialog = field && field.hideInLookupDialog;
    return {
      id: m.fieldId,
      name: helpers.cleanupHtmlMarkup(name),
      hideInLookupDialog: hideInLookupDialog
    };
  });
};

var getErrorMessage = function getErrorMessage(error, filePath) {
  var prettyError = Utils.getPrettyError(error);
  var isNotFoundError = prettyError.includes('could not be found');
  return isNotFoundError ? getNotFoundMessage(filePath) : prettyError;
};
/**
 * Create a new object used in lookup dialog from a row model
 * @param {import('./types').EcrionFieldsBinding} fieldsBinding
 * @param {import('./types').lookupApiResult} result
 * @param {[{filterBy:string, filterByValue:string}]} filters
 */


var getLookupRowsFromResult = function getLookupRowsFromResult(fieldsBinding, result, filters) {
  var rows = result.rows.map(function (row) {
    return {
      id: row.Context,
      context: row.Context,
      values: fieldsBinding.fields.map(function (field) {
        var idx = result.columnNames.indexOf(field.source);
        var value = row.values[idx];
        return {
          id: field.fieldId,
          value: value
        };
      })
    };
  });
  if (!filters || !filters.length) return rows;
  return rows.filter(function (row) {
    var filtered = false;
    filters.forEach(function (filter) {
      if (!filter.filterByValue || filtered) return;
      var column = row.values.find(function (value) {
        return value.id === filter.filterBy;
      });
      var columnValue = column && column.value;
      if (!columnValue || columnValue.toLowerCase().indexOf(filter.filterByValue.toLowerCase()) === -1) filtered = filtered || true;
    });
    return !filtered;
  });
};
/**
 * Create a new object used in lookup dialog from a column model
 * @param {import('./types').EcrionFieldsBinding} fieldsBinding
 * @param {import('../logic/types').EcrionFormState} form
 */


var getLookupColumnsFromResult = function getLookupColumnsFromResult(fieldsBinding, form) {
  return readColumns(fieldsBinding, form.fields);
};

var getNotFoundMessage = function getNotFoundMessage(filePath) {
  return "The lookup cannot be performed. The data source \"".concat(filePath, "\" could not be found.");
};

var DEFAULT_VIEW_CONFIG = {
  page: 0,
  itemsPerPage: 100,
  by: '',
  sort: ''
};

var DEFAULT_FILTER_CONFIG = function DEFAULT_FILTER_CONFIG() {
  return {
    filters: [],
    search: ''
  };
};
/**
 * @param {import('./types').useBindingHookDataType} bindingData
 * @returns {import('./types').LookupResult}
 */


var useLookup = function useLookup(bindingData) {
  var _useFormContext = useFormContext(),
      form = _useFormContext.state;

  var environmentVars = form.context.environmentVars;
  var _form$options = form.options,
      workspace = _form$options.workspace,
      jobId = _form$options.jobId;
  var contactId = environmentVars && environmentVars['ContactId'];
  var dataFilter = useRef(DEFAULT_FILTER_CONFIG());

  var _useState = useState({
    view: DEFAULT_VIEW_CONFIG,
    loading: true,
    error: '',
    searchLabel: '',
    columns: readColumns(bindingData && bindingData.fieldsBinding, form.fields),
    rows: []
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var setLookup = function setLookup(loading, error, searchLabel, columns, rows, view) {
    setState(function (crtState) {
      return {
        loading: loading,
        error: error,
        searchLabel: searchLabel,
        columns: columns,
        rows: rows,
        view: view || crtState.view
      };
    });
  };

  useEffect(function () {
    if (!bindingData) return;
    dataFilter.current = DEFAULT_FILTER_CONFIG();
    var dataSource = bindingData.dataSource,
        xpath = bindingData.xpath,
        fieldsBinding = bindingData.fieldsBinding;
    var fields = fieldsBinding.fields.map(function (m) {
      return m.source;
    });
    var parameters = fieldsBinding.params.map(function (p) {
      return {
        Name: p.name,
        Value: p.value,
        Id: p.fieldIdWithSuffix
      };
    });
    contactId && parameters.push({
      Name: 'ContactId',
      Value: contactId,
      Id: ''
    });
    setLookup(true, '', bindingData.searchLabel, readColumns(bindingData && bindingData.fieldsBinding, form.fields), [], DEFAULT_VIEW_CONFIG);
    var filter = {
      jobId: jobId || ''
    };
    lookup(workspace, dataSource, xpath, fields, parameters, filter).then(function (result) {
      var columns = getLookupColumnsFromResult(fieldsBinding, form);
      var rows = getLookupRowsFromResult(fieldsBinding, result, []);
      setLookup(false, '', bindingData.searchLabel, columns, rows, DEFAULT_VIEW_CONFIG);
    }, function (error) {
      var errorMessage = getErrorMessage(error, dataSource);
      setLookup(false, errorMessage, bindingData.searchLabel, [], [], DEFAULT_VIEW_CONFIG);
    });
  }, [bindingData]);
  /**@type {import('./types').FilterFunction} */

  var setFilterByColumn = function setFilterByColumn(columnId, value) {
    var filters = dataFilter.current.filters;
    var filter = filters.find(function (f) {
      return f.filterBy === columnId;
    }); // remove it first

    if (filter) filters.splice(filters.indexOf(filter), 1);
    if (value) filters.push({
      filterBy: columnId,
      filterByValue: value
    });
  };

  var applyFilter = function applyFilter() {
    var dataSource = bindingData.dataSource,
        xpath = bindingData.xpath,
        fieldsBinding = bindingData.fieldsBinding;
    var fields = fieldsBinding.fields.map(function (m) {
      return m.source;
    });
    var parameters = fieldsBinding.params.map(function (p) {
      return {
        Name: p.name,
        Value: p.value,
        Id: p.fieldIdWithSuffix
      };
    });
    contactId && parameters.push({
      Name: 'ContactId',
      Value: contactId,
      Id: ''
    });
    setLookup(true, '', bindingData.searchLabel, readColumns(bindingData && bindingData.fieldsBinding, form.fields), []);
    var filter = {
      filterValue: dataFilter.current.search,
      jobId: jobId || ''
    };
    lookup(workspace, dataSource, xpath, fields, parameters, filter).then(function (result) {
      var columns = getLookupColumnsFromResult(fieldsBinding, form);
      var rows = getLookupRowsFromResult(fieldsBinding, result, dataFilter.current.filters);
      setLookup(false, '', bindingData.searchLabel, columns, rows);
    }, function (error) {
      var errorMessage = getErrorMessage(error, dataSource);
      setLookup(false, errorMessage, bindingData.searchLabel, [], []);
    });
  };
  /**@type {import('./types').FilterFunction} */


  var filter = function filter(columnId, value) {
    if (!bindingData) return;
    if (columnId) setFilterByColumn(columnId, value);else dataFilter.current.search = value;
    return applyFilter();
  };
  /**@type {import('./types').ChangePageFunction} */


  var changePage = function changePage(pageNumber) {
    setState(function (crtState) {
      return _objectSpread({}, crtState, {
        view: _objectSpread({}, crtState.view, {
          page: pageNumber
        })
      });
    });
  };
  /**@type {import('./types').SortFunction} */


  var sort = function sort(columnId) {
    setState(function (crtState) {
      if (crtState.view.by === columnId) return _objectSpread({}, crtState, {
        view: _objectSpread({}, crtState.view, {
          sort: crtState.view.sort === 'asc' ? 'desc' : 'asc'
        })
      });
      return _objectSpread({}, crtState, {
        view: _objectSpread({}, crtState.view, {
          by: columnId,
          sort: 'asc'
        })
      });
    });
  };

  return _objectSpread({}, state, {
    actions: {
      filter: filter,
      changePage: changePage,
      sort: sort
    }
  });
};

export default useLookup;